import { render, staticRenderFns } from "./AptoMedicoForm.vue?vue&type=template&id=3245b14a&scoped=true&"
import script from "./AptoMedicoForm.vue?vue&type=script&lang=js&"
export * from "./AptoMedicoForm.vue?vue&type=script&lang=js&"
import style0 from "./AptoMedicoForm.vue?vue&type=style&index=0&id=3245b14a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3245b14a",
  null
  
)

export default component.exports